/*
 * Knowledge Messages
 *
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  knowledge: {
    id: 'app.knowledge',
    defaultMessage: 'Knowledge',
  },
  knowledgeMap: {
    id: 'app.knowledge.knowledgeMap',
    defaultMessage: 'Knowledge Map',
  },
  downloadTemplate: {
    id: `app.knowledge.download.template`,
    defaultMessage: 'Download Template',
  },
  id: {
    id: 'app.knowledge.download.header1',
    defaultMessage: 'ID',
  },
  learningObjectiveTitle: {
    id: 'app.knowledge.download.header2',
    defaultMessage: 'LO title',
  },
  enablingObjectiveTitle: {
    id: 'app.knowledge.download.header3',
    defaultMessage: 'EO title',
  },
  EOLORelation: {
    id: 'app.knowledge.download.header4',
    defaultMessage: 'What is the LO for this EO',
  },
  description: {
    id: 'app.knowledge.download.header5',
    defaultMessage: 'Description',
  },
  shortCode: {
    id: 'app.knowledge.download.header6',
    defaultMessage: 'Short Code',
  },
  selectButton: {
    id: 'app.knowledge.download.header7',
    defaultMessage: 'Select',
  },
  duplicateSuccess: {
    id: 'app.knowledge.download.header8',
    defaultMessage: 'The Selected KnowledgeMap is Duplicated.',
  },
  copyOf: {
    id: 'app.knowledge.download.header9',
    defaultMessage: 'Copy of ',
  },
  errorMessage: {
    id: 'app.knowledge.download.header10',
    defaultMessage: 'We’re still working on the Knowledge page. This will be where you create and edit Knowledge and Competency maps.',
  },
  competenciesComingSoon: {
    id: 'app.knowledge.download.header11',
    defaultMessage: 'Competencies Coming Soon',
  },
});
